const config = {
  api: {
    portalLocal: 'http://10.0.0.97:3300',
    customer: 'https://beta-th-customer-api.dimorder.com',
    dimorder: 'https://beta-th-api.dimorder.com',
    node: 'https://beta-th-node.dimorder.com',
  },
  env: 'beta',
  keetaAppId: '3371649213',
  receipt: 'https://beta-th-mp-order.dimorder.com/',
  report: 'https://beta-th-report-api.dimorder.com/report/',
}

export default config
